import React from 'react';
import { cn } from '../utils/cn';

export const Label = ({ className, children, htmlFor, ...props }) => (
  <label
    htmlFor={htmlFor}
    className={cn('block text-sm font-medium text-gray-700 mb-2', className)}
    {...props}
  >
    {children}
  </label>
);

export const Input = React.forwardRef(({ className, type = 'text', ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      'w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed',
      className
    )}
    {...props}
  />
));

Input.displayName = 'Input';

export const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed resize-none',
      className
    )}
    {...props}
  />
));

Textarea.displayName = 'Textarea';

export const Select = React.forwardRef(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      'w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed',
      className
    )}
    {...props}
  >
    {children}
  </select>
));

Select.displayName = 'Select';
